import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Link, graphql } from 'gatsby'
import shortid from 'shortid'
import SEO from '../components/atoms/SEO'
import ProjectImage from '../components/atoms/ProjectImage'
import styles from './index.module.css'
import Icon from '../components/atoms/Icon'

import TagData from '../../content/tag.yml'

function getImageCount(images, slug) {
  let array = []
  let slugWithoutSlashes = slug.replace(/\//g, '')

  images.map(
    ({ node }) => node.name.includes(slugWithoutSlashes) && array.push(node)
  )

  return array.length
}

Project.propTypes = {
  node: PropTypes.shape({
    slug: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    img: PropTypes.object.isRequired
  }),
  images: PropTypes.array.isRequired
}

function Project({ node, images }) {
  const { slug, title, img } = node
  const imageCount = getImageCount(images, slug)

  return (
    <article className={styles.project} key={slug}>
      <Link to={slug}>
        <h1 className={styles.title}>{title}</h1>
        <ProjectImage fluid={img.childImageSharp.fluid} alt={title.TED} />

        {imageCount > 1 && (
          <small
            className={styles.imageCount}
            title={`${imageCount} project images`}
          >
            <Icon name="Image" /> {imageCount}
          </small>
        )}
      </Link>
    </article>
  )
}

Inventor.propTypes = {
  data: PropTypes.object.isRequired,
  pageContext: PropTypes.object.isRequired
}

function Inventor({ data, pageContext }) {
  //const projects = data.allProjectsYaml.edges
  const projects = data.allSengehdataYaml.edges
  const images = data.projectImageFiles.edges

  return (
    <>
      <SEO />
      <div
        style={{
          paddingLeft: 20,
          paddingRight: 20,
          paddingBottom: 30,
          marginLeft: 'auto',
          marginRight: 'auto',
          maxWidth: 960,
          alignItems: 'center'
        }}
      >
        <p className={`p-job-title ${styles.logo}`}>
          {<Link to={'/entrepreneur/'}>Public Servant & Entrepreneur</Link>}
        </p>
        <div
          className={styles.description}
          dangerouslySetInnerHTML={{ __html: TagData.publicServant }}
        />
      </div>
      <div className={styles.projects}>
        {projects.map(({ node }) => (
          <Project key={shortid.generate()} node={node} images={images} />
        ))}
        {/* {projects.map(({ node }) => {
          //console.log(node)
          let slugData = []
          let titleData = []
          let imgData = []
          node.frontmatter.multiple.forEach((slu) => slugData.push(slu.slug))
          node.frontmatter.multiple.forEach((tit) => titleData.push(tit.title))
          node.frontmatter.multiple.forEach((im) => imgData.push(im.img))
          const [slug] = slugData
          const [title] = titleData
          const [img] = imgData

          return (
            <Project
              key={shortid.generate()}
              title={title}
              img={img}
              slug={slug}
              images={images}
            />
          )
        })} */}
      </div>
    </>
  )
}

export default memo(Inventor)

export const IndexQuery = graphql`
  query {
    allSengehdataYaml(filter: { tag: { eq: "p&e" } }) {
      edges {
        node {
          title
          slug
          img {
            childImageSharp {
              fluid(maxWidth: 980, quality: 85) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      }
    }

    projectImageFiles: allFile(
      filter: { absolutePath: { regex: "/portfolio/" } }
    ) {
      edges {
        node {
          name
        }
      }
    }
  }
`

// import React, { memo } from 'react'
// import PropTypes from 'prop-types'
// import { Link, graphql } from 'gatsby'
// import shortid from 'shortid'
// import SEO from '../components/atoms/SEO'
// import ProjectImage from '../components/atoms/ProjectImage'
// import styles from './index.module.css'
// import Icon from '../components/atoms/Icon'

// import TagData from '../../content/tag.yml'

// function getImageCount(images, slug) {
//   let array = []
//   let slugWithoutSlashes = slug.replace(/\//g, '')

//   images.map(
//     ({ node }) => node.name.includes(slugWithoutSlashes) && array.push(node)
//   )

//   return array.length
// }

// Project.propTypes = {
//   node: PropTypes.shape({
//     slug: PropTypes.string.isRequired,
//     title: PropTypes.string.isRequired,
//     img: PropTypes.object.isRequired
//   }),
//   images: PropTypes.array.isRequired
// }

// function Project({ node, images }) {
//   const { slug, title, img } = node
//   const imageCount = getImageCount(images, slug)

//   return (
//     <article className={styles.project} key={slug}>
//       <Link to={slug}>
//         <h1 className={styles.title}>{title}</h1>
//         <ProjectImage fluid={img.childImageSharp.fluid} alt={title.TED} />

//         {imageCount > 1 && (
//           <small
//             className={styles.imageCount}
//             title={`${imageCount} project images`}
//           >
//             <Icon name="Image" /> {imageCount}
//           </small>
//         )}
//       </Link>
//     </article>
//   )
// }

// Inventor.propTypes = {
//   data: PropTypes.object.isRequired,
//   pageContext: PropTypes.object.isRequired
// }

// function Inventor({ data, pageContext }) {
//   const projects = data.allProjectsYaml.edges
//   const images = data.projectImageFiles.edges

//   return (
//     <>
//       <SEO />
//       <div
//         style={{
//           paddingLeft: 20,
//           paddingRight: 20,
//           paddingBottom: 30,
//           marginLeft: 'auto',
//           marginRight: 'auto',
//           maxWidth: 960,
//           alignItems: 'center'
//         }}
//       >
//       <p className={`p-job-title ${styles.logo}`}>
//         {<Link to={'/entrepreneur/'}>Public Servant & Entrepreneur</Link>}
//       </p>
//         <div
//           className={styles.description}
//           dangerouslySetInnerHTML={{ __html: TagData.publicServant }}
//         />
//       </div>
//       <div className={styles.projects}>
//         {projects.map(({ node }) => (
//           <Project key={shortid.generate()} node={node} images={images} />
//         ))}
//       </div>
//     </>
//   )
// }

// export default memo(Inventor)

// export const IndexQuery = graphql`
//   query {
//     allProjectsYaml(
//       filter: {tag: {eq: "p&e"}}
//     ) {
//       edges {
//         node {
//           title
//           slug
//           img {
//             childImageSharp {
//               fluid(maxWidth: 980, quality: 85) {
//                 ...GatsbyImageSharpFluid_withWebp
//               }
//             }
//           }
//         }
//       }
//     }

//     projectImageFiles: allFile(
//       filter: { absolutePath: { regex: "/portfolio/" } }
//     ) {
//       edges {
//         node {
//           name
//         }
//       }
//     }
//   }
// `
